export const translations = {
  pt: {
    "brand.tagline": "Advocacia · Direito da UE",
    "site.title": "Advogada | Direito Civil & Penal | LL.M. Direito da UE",
    "site.positioning": "Advocacia com rigor e propósito ético — da prática forense diária à causa da proteção animal na União Europeia.",
    "site.oa": "Advogada inscrita na Ordem dos Advogados — Conselho Regional do Porto",
    "nav.home": "Início",
    "nav.about": "Sobre Mim",
    "nav.blog": "Blog",
    "nav.booking": "Agendamento",
    "nav.cta": "Marcar Consulta",
    "hero.line1": "Advocacia com rigor,",
    "hero.line2a": "do Civil ao",
    "hero.line2b": "Direito",
    "hero.line3": "Animal.",
    "hero.positioning": "Advocacia geral — Direito Civil, Direito Penal, Direito da União Europeia e Direito Animal — com rigor académico e propósito ético.",
    "hero.trust": "Porto · Lisboa · Bruxelas",
    "marquee.items": ["Direito Civil & Penal", "LL.M. Direito da UE", "Oxford Centre for Animal Ethics", "Publicações UNIO", "Proteção Animal — Meta de Futuro", "Porto · Lisboa · Bruxelas"],
    "practice.overline": "Áreas de Atuação",
    "practice.title": "Prática forense com propósito",
    "practice.intro": "Prática generalista em Direito Civil e Penal, com a solidez de um LL.M. em Direito da UE — e uma área de dedicação especial: o Direito Animal.",
    "practice.areas": [
      { n: "01", title: "Direito Civil", text: "Contratos, responsabilidade civil, família e sucessões — aconselhamento e contencioso com atenção ao detalhe." },
      { n: "02", title: "Direito Penal", text: "Defesa técnica rigorosa em processo-crime, queixas e acompanhamento em todas as fases processuais." },
      { n: "03", title: "Direito da União Europeia", text: "Regulamentos, diretivas e jurisprudência do TJUE aplicados ao caso concreto — do parecer ao litígio." },
      { n: "04", title: "Direito Animal", text: "Também pratico Direito Animal — proteção jurídica dos animais, com formação especializada em Oxford e Antuérpia." },
    ],
    "credentials.overline": "Formação & Credenciais",
    "credentials.title": "Rigor académico ao serviço da advocacia",
    "credentials.items": [
      { place: "Oxford", title: "Oxford Centre for Animal Ethics", text: "Formação especializada em ética animal e direito, no centro de estudos da Universidade de Oxford." },
      { place: "Antuérpia", title: "Universidade de Antuérpia", text: "Aprofundamento em direito europeu e comparado da proteção animal." },
      { place: "CRIAP", title: "CRIAP", text: "Formação avançada em políticas públicas e investigação aplicada à causa animal." },
      { place: "UNIO", title: "Publicações Científicas", text: "Artigos na UNIO — EU Law Journal sobre o estatuto jurídico dos animais na União Europeia." },
    ],
    "blogPreview.overline": "Blog Jurídico",
    "blogPreview.title": "Leituras & análise recente",
    "blogPreview.viewAll": "Ver todos os artigos",
    "blogPreview.emptyTitle": "Em preparação.",
    "blogPreview.emptyText": "Os primeiros artigos de análise jurídica estão a ser redigidos. Volte em breve para ler sobre Direito Animal da UE e jurisprudência do TJUE.",
    "homeCta.overline": "Consultas & Colaborações",
    "homeCta.title": "Falemos sobre o seu caso.",
    "homeCta.text": "Consulta inicial, revisão de caso ou colaboração académica e institucional — presencial em Vila Verde ou online.",
    "homeCta.button": "Marcar Consulta",
    "blog.overline": "Blog Jurídico",
    "blog.title1": "Leituras &",
    "blog.title2": "análise jurídica.",
    "blog.intro": "Comentário jurídico sobre Direito Civil, Penal e Direito da UE — com atenção especial ao Direito Animal, a causa que orienta o meu projeto de futuro.",
    "blog.search": "Pesquisar artigos…",
    "blog.readMore": "Ler artigo",
    "blog.loading": "A carregar…",
    "blog.emptyPrepTitle": "Em preparação.",
    "blog.emptyPrep": "Os primeiros artigos estão a ser redigidos. Volte em breve para ler análises sobre Direito Animal da UE.",
    "blog.emptyNoneTitle": "Sem resultados.",
    "blog.emptyNone": "Nenhum artigo corresponde aos critérios selecionados. Experimente outra categoria ou termo de pesquisa.",
    "cat.Todos": "Todos",
    "cat.Legislação UE": "Legislação UE",
    "cat.Jurisprudência": "Jurisprudência",
    "cat.Fauna Selvagem": "Fauna Selvagem",
    "cat.Animais de Companhia": "Animais de Companhia",
    "cat.Artigos Académicos": "Artigos Académicos",
    "article.back": "Blog",
    "article.by": "Por",
    "article.copy": "Copiar ligação",
    "article.copied": "Ligação copiada",
    "article.minRead": "min de leitura",
    "article.notFound": "Artigo não encontrado.",
    "article.loading": "A carregar…",
    "booking.overline": "Agendamento",
    "booking.title1": "Marcar",
    "booking.title2": "consulta.",
    "booking.intro": "Indique o enquadramento do seu caso e a disponibilidade preferencial. Cada pedido é analisado pessoalmente antes da confirmação da marcação.",
    "booking.types": [
      { title: "Consulta Inicial", duration: "60 min", text: "Diagnóstico do caso, enquadramento jurídico e estratégia possível." },
      { title: "Revisão de Caso", duration: "60 min", text: "Análise de processo em curso, parecer sobre peças processuais ou decisões." },
      { title: "Colaboração Académica / Institucional", duration: "30 min", text: "Parcerias de investigação, consultoria a ONGs e apoio legislativo." },
    ],
    "booking.formatOnline": "Online — videochamada segura",
    "booking.formatInPerson": "Presencial — escritório de Vila Verde",
    "booking.deont": "A prestação de serviços advocatícios rege-se pelo Estatuto da Ordem dos Advogados e pelo sigilo profissional. Os honorários são comunicados antes de qualquer compromisso.",
    "booking.formTitle": "Pedido de Marcação",
    "booking.labelName": "Nome completo *",
    "booking.labelEmail": "Email *",
    "booking.labelPhone": "Telefone",
    "booking.labelEntity": "Tipo de entidade",
    "booking.labelType": "Tipo de consulta",
    "booking.labelFormat": "Formato",
    "booking.labelDate": "Data e horário preferencial",
    "booking.labelSubject": "Assunto *",
    "booking.labelMessage": "Resumo do caso",
    "booking.phName": "O seu nome",
    "booking.phEmail": "nome@email.com",
    "booking.phPhone": "+351 …",
    "booking.phSubject": "Ex.: Maus-tratos a animal de companhia — vizinhança",
    "booking.phMessage": "Descreva brevemente a situação (confidencial).",
    "booking.entities": [
      { value: "Particular", label: "Particular" },
      { value: "ONG / Associação", label: "ONG / Associação" },
      { value: "Empresa", label: "Empresa" },
      { value: "Instituição Pública", label: "Instituição Pública" },
      { value: "Academia / Investigação", label: "Academia / Investigação" },
    ],
    "booking.consultOptions": [
      { value: "Consulta Inicial (60 min)", label: "Consulta Inicial (60 min)" },
      { value: "Revisão de Caso (60 min)", label: "Revisão de Caso (60 min)" },
      { value: "Colaboração Académica / Institucional (30 min)", label: "Colaboração Académica / Institucional (30 min)" },
    ],
    "booking.formatOptions": [
      { value: "Online (videochamada)", label: "Online (videochamada)" },
      { value: "Presencial — Vila Verde", label: "Presencial — Vila Verde" },
    ],
    "booking.submit": "Enviar Pedido de Marcação",
    "booking.sending": "A enviar…",
    "booking.disclaimer": "Ao submeter, aceita ser contactado(a) por email ou telefone. Os dados são tratados com confidencialidade profissional.",
    "booking.toastSuccess": "Pedido enviado com sucesso.",
    "booking.toastSuccessDesc": "Será contactado(a) por email no prazo de 48 horas úteis.",
    "booking.toastError": "Não foi possível enviar o pedido.",
    "about.overline": "Sobre Mim",
    "about.bio1": "Sou advogada de prática geral — Direito Civil, Direito Penal e Direito da União Europeia — e acredito que o Direito é, acima de tudo, uma ferramenta ao serviço das pessoas.",
    "about.bio2": "Formada pela Universidade do Minho e mestre em Direito da UE, somei formação especializada em Direito Animal — Oxford Centre for Animal Ethics, Universidade de Antuérpia e CRIAP — uma área que também integro na minha prática.",
    "manifesto.overline": "Manifesto",
    "manifesto.title": "Três capítulos, um propósito",
    "about.chapters": [
      { n: "01", title: "Formação Jurídica", text: "Licenciatura em Direito pela Universidade do Minho e LL.M. em Direito da União Europeia. Estágio profissional na Ordem dos Advogados — Conselho Regional do Porto, com prática em Direito Civil e Penal." },
      { n: "02", title: "Especialização Internacional", text: "Formação avançada em Direito Animal no Oxford Centre for Animal Ethics, na Universidade de Antuérpia e no CRIAP — três escolas que unem ética, direito comparado e políticas públicas." },
      { n: "03", title: "Missão de Longo Prazo", text: "Construir, em Portugal, uma iniciativa jurídica de proteção animal inspirada no modelo da ClientEarth — litígio estratégico e advocacia institucional ao serviço de quem não tem voz." },
    ],
    "about.quote": "«Os animais não precisam da nossa compaixão ocasional; precisam do nosso rigor permanente.»",
    "journey.overline": "Percurso",
    "journey.title": "Uma trajetória deliberada",
    "journey.intro": "Cada etapa foi escolhida para aproximar a advocacia portuguesa dos padrões internacionais de proteção animal.",
    "about.timeline": [
      { year: "Formação", text: "Licenciatura em Direito — Universidade do Minho" },
      { year: "Pós-graduação", text: "LL.M. em Direito da União Europeia" },
      { year: "Estágio", text: "Estágio profissional — Ordem dos Advogados, Porto" },
      { year: "Oxford", text: "Oxford Centre for Animal Ethics — formação especializada" },
      { year: "Antuérpia", text: "Universidade de Antuérpia — direito europeu e comparado" },
      { year: "CRIAP", text: "CRIAP — políticas públicas e investigação aplicada" },
    ],
    "pubs.overline": "Publicações & Colaborações",
    "pubs.title": "Investigação publicada",
    "footer.contacts": "Contactos",
    "footer.nav": "Navegação",
    "footer.rights": "Todos os direitos reservados",
    "footer.admin": "Área Reservada",
    "footer.offices": "Escritório",
    "seo.home": "Advogada em Vila Verde e Braga | Civil, Penal, UE e Direito Animal",
    "seo.home.desc": "Advogada em Vila Verde (Braga) — Direito Civil, Penal, Direito da UE e Direito Animal. LL.M., formação em Oxford. Presencial em Vila Verde e online para todo o país.",
    "seo.about": "Sobre Mim — Advogada em Vila Verde, Percurso e Publicações",
    "seo.about.desc": "Advogada em Vila Verde (Braga). Percurso da Dra. Luísa Azevedo Lopes: Universidade do Minho, LL.M. em Direito da UE, Oxford Centre for Animal Ethics e publicações na UNIO.",
    "seo.blog": "Blog Jurídico — Direito Animal, Civil, Penal e UE | Advogada em Vila Verde",
    "seo.blog.desc": "Blog jurídico de uma advogada de Vila Verde (Braga): análise de Direito Animal, Civil, Penal e Direito da União Europeia, com rigor académico e linguagem clara.",
    "seo.booking": "Marcar Consulta — Online ou Presencial em Vila Verde",
    "seo.booking.desc": "Marque uma consulta jurídica online (todo o país) ou presencial em Vila Verde — ao serviço de Braga e região. Consulta inicial, revisão de caso ou colaboração institucional.",
    "notFound.title": "Página não encontrada.",
    "notFound.back": "Voltar ao início",
  },
  en: {
    "brand.tagline": "Legal Practice · EU Law",
    "site.title": "Lawyer | Civil & Criminal Law | LL.M. in EU Law",
    "site.positioning": "Legal practice with rigour and ethical purpose — from daily advocacy to the cause of animal protection in the European Union.",
    "site.oa": "Lawyer admitted to the Portuguese Bar Association — Porto Regional Council",
    "nav.home": "Home",
    "nav.about": "About Me",
    "nav.blog": "Blog",
    "nav.booking": "Appointments",
    "nav.cta": "Book a Consultation",
    "hero.line1": "Rigorous legal practice,",
    "hero.line2a": "from Civil Law",
    "hero.line2b": "to Animal",
    "hero.line3": "Law.",
    "hero.positioning": "General legal practice — Civil Law, Criminal Law, European Union Law and Animal Law — with academic rigour and ethical purpose.",
    "hero.trust": "Porto · Lisbon · Brussels",
    "marquee.items": ["Civil & Criminal Law", "LL.M. in EU Law", "Oxford Centre for Animal Ethics", "UNIO Publications", "Animal Protection — The Goal Ahead", "Porto · Lisbon · Brussels"],
    "practice.overline": "Practice Areas",
    "practice.title": "A practice with purpose",
    "practice.intro": "General practice in Civil and Criminal Law, backed by an LL.M. in EU Law — and one area of special dedication: Animal Law.",
    "practice.areas": [
      { n: "01", title: "Civil Law", text: "Contracts, civil liability, family and succession law — advice and litigation with attention to detail." },
      { n: "02", title: "Criminal Law", text: "Rigorous technical defence in criminal proceedings, complaints and representation at every stage." },
      { n: "03", title: "European Union Law", text: "Regulations, directives and CJEU case law applied to the concrete case — from legal opinion to litigation." },
      { n: "04", title: "Animal Law", text: "Animal law is also part of my practice — legal protection of animals backed by specialised training at Oxford and Antwerp." },
    ],
    "credentials.overline": "Education & Credentials",
    "credentials.title": "Academic rigour in the service of advocacy",
    "credentials.items": [
      { place: "Oxford", title: "Oxford Centre for Animal Ethics", text: "Specialised training in animal ethics and law at the University of Oxford's study centre." },
      { place: "Antwerp", title: "University of Antwerp", text: "Advanced study of European and comparative animal protection law." },
      { place: "CRIAP", title: "CRIAP", text: "Advanced training in public policy and research applied to the animal cause." },
      { place: "UNIO", title: "Academic Publications", text: "Articles in UNIO — EU Law Journal on the legal status of animals in the European Union." },
    ],
    "blogPreview.overline": "Legal Blog",
    "blogPreview.title": "Recent readings & analysis",
    "blogPreview.viewAll": "View all articles",
    "blogPreview.emptyTitle": "In preparation.",
    "blogPreview.emptyText": "The first legal analysis articles are being written. Check back soon to read about EU Animal Law and CJEU case law.",
    "homeCta.overline": "Consultations & Collaborations",
    "homeCta.title": "Let's talk about your case.",
    "homeCta.text": "Initial consultation, case review or academic and institutional collaboration — in person in Vila Verde or online.",
    "homeCta.button": "Book a Consultation",
    "blog.overline": "Legal Blog",
    "blog.title1": "Legal readings &",
    "blog.title2": "analysis.",
    "blog.intro": "Legal commentary on Civil, Criminal and EU Law — with special attention to Animal Law, the cause guiding my future project.",
    "blog.search": "Search articles…",
    "blog.readMore": "Read article",
    "blog.loading": "Loading…",
    "blog.emptyPrepTitle": "In preparation.",
    "blog.emptyPrep": "The first articles are being written. Check back soon for analysis of EU Animal Law.",
    "blog.emptyNoneTitle": "No results.",
    "blog.emptyNone": "No articles match the selected criteria. Try another category or search term.",
    "cat.Todos": "All",
    "cat.Legislação UE": "EU Legislation",
    "cat.Jurisprudência": "Case Law",
    "cat.Fauna Selvagem": "Wildlife",
    "cat.Animais de Companhia": "Companion Animals",
    "cat.Artigos Académicos": "Academic Articles",
    "article.back": "Blog",
    "article.by": "By",
    "article.copy": "Copy link",
    "article.copied": "Link copied",
    "article.minRead": "min read",
    "article.notFound": "Article not found.",
    "article.loading": "Loading…",
    "booking.overline": "Appointments",
    "booking.title1": "Book a",
    "booking.title2": "consultation.",
    "booking.intro": "Describe the context of your case and your preferred availability. Each request is reviewed personally before the appointment is confirmed.",
    "booking.types": [
      { title: "Initial Consultation", duration: "60 min", text: "Case diagnosis, legal framework and possible strategy." },
      { title: "Case Review", duration: "60 min", text: "Analysis of ongoing proceedings, opinions on pleadings or decisions." },
      { title: "Academic / Institutional Collaboration", duration: "30 min", text: "Research partnerships, consultancy for NGOs and legislative support." },
    ],
    "booking.formatOnline": "Online — secure video call",
    "booking.formatInPerson": "In person — Vila Verde office",
    "booking.deont": "Legal services are governed by the Statute of the Portuguese Bar Association and by professional secrecy. Fees are communicated before any engagement.",
    "booking.formTitle": "Booking Request",
    "booking.labelName": "Full name *",
    "booking.labelEmail": "Email *",
    "booking.labelPhone": "Phone",
    "booking.labelEntity": "Entity type",
    "booking.labelType": "Consultation type",
    "booking.labelFormat": "Format",
    "booking.labelDate": "Preferred date and time",
    "booking.labelSubject": "Subject *",
    "booking.labelMessage": "Case summary",
    "booking.phName": "Your name",
    "booking.phEmail": "name@email.com",
    "booking.phPhone": "+351 …",
    "booking.phSubject": "E.g.: Mistreatment of a companion animal — neighbourhood dispute",
    "booking.phMessage": "Briefly describe the situation (confidential).",
    "booking.entities": [
      { value: "Particular", label: "Individual" },
      { value: "ONG / Associação", label: "NGO / Association" },
      { value: "Empresa", label: "Company" },
      { value: "Instituição Pública", label: "Public Institution" },
      { value: "Academia / Investigação", label: "Academia / Research" },
    ],
    "booking.consultOptions": [
      { value: "Consulta Inicial (60 min)", label: "Initial Consultation (60 min)" },
      { value: "Revisão de Caso (60 min)", label: "Case Review (60 min)" },
      { value: "Colaboração Académica / Institucional (30 min)", label: "Academic / Institutional Collaboration (30 min)" },
    ],
    "booking.formatOptions": [
      { value: "Online (videochamada)", label: "Online (video call)" },
      { value: "Presencial — Vila Verde", label: "In person — Vila Verde" },
    ],
    "booking.submit": "Send Booking Request",
    "booking.sending": "Sending…",
    "booking.disclaimer": "By submitting, you agree to be contacted by email or phone. Your data is handled with professional confidentiality.",
    "booking.toastSuccess": "Request sent successfully.",
    "booking.toastSuccessDesc": "You will be contacted by email within 48 business hours.",
    "booking.toastError": "Could not send the request.",
    "about.overline": "About Me",
    "about.bio1": "I am a general practice lawyer — Civil Law, Criminal Law and European Union Law — and I believe the law is, above all, a tool at the service of people.",
    "about.bio2": "A graduate of the University of Minho with an LL.M. in EU Law, I added specialised training in Animal Law — the Oxford Centre for Animal Ethics, the University of Antwerp and CRIAP — an area I also integrate into my practice.",
    "manifesto.overline": "Manifesto",
    "manifesto.title": "Three chapters, one purpose",
    "about.chapters": [
      { n: "01", title: "Legal Education", text: "Law degree from the University of Minho and an LL.M. in European Union Law. Professional traineeship at the Portuguese Bar Association — Porto Regional Council, practising Civil and Criminal Law." },
      { n: "02", title: "International Specialisation", text: "Advanced training in Animal Law at the Oxford Centre for Animal Ethics, the University of Antwerp and CRIAP — three schools uniting ethics, comparative law and public policy." },
      { n: "03", title: "Long-Term Mission", text: "To build in Portugal a legal animal-protection initiative inspired by the ClientEarth model — strategic litigation and institutional advocacy in the service of those who have no voice." },
    ],
    "about.quote": "«Animals do not need our occasional compassion; they need our permanent rigour.»",
    "journey.overline": "Background",
    "journey.title": "A deliberate path",
    "journey.intro": "Each step was chosen to bring Portuguese advocacy closer to international animal-protection standards.",
    "about.timeline": [
      { year: "Education", text: "Law degree — University of Minho" },
      { year: "Postgraduate", text: "LL.M. in European Union Law" },
      { year: "Traineeship", text: "Professional traineeship — Portuguese Bar Association, Porto" },
      { year: "Oxford", text: "Oxford Centre for Animal Ethics — specialised training" },
      { year: "Antwerp", text: "University of Antwerp — European and comparative law" },
      { year: "CRIAP", text: "CRIAP — public policy and applied research" },
    ],
    "pubs.overline": "Publications & Collaborations",
    "pubs.title": "Published research",
    "footer.contacts": "Contacts",
    "footer.nav": "Navigation",
    "footer.rights": "All rights reserved",
    "footer.admin": "Admin Area",
    "footer.offices": "Office",
    "seo.home": "Lawyer in Vila Verde & Braga | Civil, Criminal, EU and Animal Law",
    "seo.home.desc": "Lawyer in Vila Verde (Braga), Portugal — Civil, Criminal, EU and Animal Law. LL.M. in EU Law, trained at Oxford. In person in Vila Verde and online nationwide.",
    "seo.about": "About Me — Lawyer in Vila Verde, Background & Publications",
    "seo.about.desc": "Lawyer in Vila Verde (Braga). The path of Dr. Luísa Azevedo Lopes: University of Minho, LL.M. in EU Law, Oxford Centre for Animal Ethics and UNIO publications.",
    "seo.blog": "Legal Blog — Animal, Civil, Criminal and EU Law | Lawyer in Vila Verde",
    "seo.blog.desc": "Legal blog by a lawyer from Vila Verde (Braga): analysis of Animal, Civil, Criminal and European Union Law, with academic rigour and clear language.",
    "seo.booking": "Book a Consultation — Online or in Vila Verde",
    "seo.booking.desc": "Book a legal consultation online (nationwide) or in person in Vila Verde — serving Braga and the region. Initial consultation, case review or institutional collaboration.",
    "notFound.title": "Page not found.",
    "notFound.back": "Back to homepage",
  },
};
